import React from 'react';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import { Link } from '@lt/components';
import { Title } from '../Title';
import { Description } from '../Description';
import { Content } from '../Content';
import { EmailButton } from '../EmailButton';

interface Props {
  email: string;
  isRestore?: boolean;
  handleGoBack: () => void;
}

export const ResetPasswordForm: React.FC<Props> = ({
  email,
  isRestore,
  handleGoBack,
}) => {
  const { t } = useTranslation();
  return (
    <PasswordForm>
      <StyledTitle>{t('checkout.passwordForm.reset.title')}</StyledTitle>
      <StyledDescription>
        {t('checkout.passwordForm.reset.description', {
          context: isRestore ? 'setting' : 'reset',
          mail: email,
        })}
      </StyledDescription>
      <StyledDescription>
        {t('checkout.passwordForm.reset.description')}
      </StyledDescription>
      <Content>
        <EmailButton email={email} />
        <GoBackLink
          href="/"
          onClick={(e) => {
            e.preventDefault();
            handleGoBack();
          }}
        >
          {t('checkout.passwordForm.reset.goBack')}
        </GoBackLink>
      </Content>
    </PasswordForm>
  );
};

const GoBackLink = styled(Link)`
  font-size: 16px;
  line-height: 20px;
`;

const PasswordForm = styled.div<{ isMobile?: boolean }>`
  width: 290px;
  margin-left: auto;
  margin-right: auto;
`;

const StyledTitle = styled(Title)`
  white-space: pre-line;
`;

const StyledDescription = styled(Description)`
  white-space: pre-line;
  padding: 0;
`;
